function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    mail\n  ");

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.8,
  y: 5.7,
  transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 29.4 32.5818)",
  className: "mail_svg__mail_svg__st0",
  width: 27.8,
  height: 21.2,
  fill: "none",
  stroke: "#717375",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 11.3,
  y1: 16.1,
  x2: 1.1,
  y2: 25.9,
  fill: "none",
  stroke: "#717375",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 18.1,
  y1: 16.1,
  x2: 28.3,
  y2: 25.9,
  fill: "none",
  stroke: "#717375",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.6,5.8L16.8,17.1c-1.2,1.2-3,1.2-4.3,0L0.8,5.8",
  fill: "none",
  stroke: "#717375",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.4 31.5",
    width: 29.4,
    height: 31.5,
    style: {
      enableBackground: "new 0 0 29.4 31.5"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgMail;